export default {"src":"/_next/static/media/faq-question-banner.7e35ce0d.svg","height":202,"width":354,"blurWidth":0,"blurHeight":0};